import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import RestaurantContextProvider from './context/RestaurantContext';
import LanguageContextProvider from './context/LanguageContext';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';

import './index.scss';
import './stylesheet/main.scss';

const hotelMenuBgImageURL =
    `${process.env.REACT_APP_AWS_ASSETS_ROOT_URL || ''}hotels/menu_bg_image_upload.jpg`;

if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty(
        '--hotel-menu-bg-image-url',
        `url('${hotelMenuBgImageURL}')`
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Provider store={store}>
            <RestaurantContextProvider>
                <LanguageContextProvider>
                    <App />
                </LanguageContextProvider>
            </RestaurantContextProvider>
        </Provider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
